module.exports = __webpack_public_path__ + "static/media/main-hero-2.18647e5b.jpg";